import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=a8f2c4c6&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"
import style0 from "./Resources.vue?vue&type=style&index=0&id=a8f2c4c6&prod&scoped=true&lang=css"
import style1 from "./Resources.vue?vue&type=style&index=1&id=a8f2c4c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f2c4c6",
  null
  
)

export default component.exports